// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM } from './Form';

const ReplySearch = () => {

   const [cnfg, set_cnfg] = React.useState({ filter: 'All Intents and Responses', index: 0 });
   const [file, set_file] = React.useState();
   const [hold, set_hold] = React.useState(0.01);
   const [json, set_json] = React.useState();
   const [mode, set_mode] = React.useState(null);
   const [ok_1, set_ok_1] = React.useState(0);
   const [ok_2, set_ok_2] = React.useState(0);
   const [ok_3, set_ok_3] = React.useState(0);
   const [rows, set_rows] = React.useState();
   const [size, set_size] = React.useState(3);
   const [type, set_type] = React.useState(0);

   const build = ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;
      const mode_default = 'Search Page Method';
      set_mode(mode_default);
      set_type(0);
      set_body(
         <>
           {warn}
           <p className="ask-henry-body-margin-bottom-x">Select the desired look-up algotihm:</p>
           <select className="ask-henry-form-input"onChange={build_mode_change} ref={method_ref}>
             <option value="0">{mode_default}</option>
             <option value="1">Similarity Search</option>
             <option value="2">Similarity Search with Rank Sum</option>
             <option value="3">English Web Search</option>
             <option value="4">English Web Search with Rank Sum</option>
             <option value="5">Bag of words</option>
           </select>
           <p className="ask-henry-body-margin-bottom-x">Select the content source:</p>
           <select className="ask-henry-form-input"onChange={build_source_change} ref={source_ref}>
             <option value="0">All Intents and Responses</option>
             <option value="1">Intents Only</option>
             <option value="2">Responses Only</option>
           </select>
           <p className="ask-henry-body-margin-bottom-x">Select a JSON file that defines an array of intents/source pairs:</p>
           <input className="ask-henry-form-input" name="file" type="file" onChange={build_file_change} />
           <p className="ask-henry-body-margin-bottom-x">Enter the search threshold:</p>
           <input className="ask-henry-form-input" defaultValue="0.01" min="0.0" onChange={build_threshold_change} ref={threshold_ref} step="0.001" type="number" />
           <p className="ask-henry-body-margin-bottom-x">Enter the list size:</p>
           <input className="ask-henry-form-input" defaultValue="3" min="1" onChange={build_size_change} ref={list_size_ref} step="1" type="number" />
         </>
      );
      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Submit</button>
           <button className="ask-henry-form-button" onClick={form_close} >Close</button>
         </>
      );
   } // build();

   const build_file_change = async (e) => {
      e.preventDefault()
      const reader  = new FileReader()
      reader.onload = async (e) => {
         set_file(e.target.result);
      };
      reader.readAsText(e.target.files[0])
   } // build_file_change();

   const build_mode_change = () => {
      set_mode(method_ref?.current?.options[method_ref?.current?.selectedIndex].text);
      set_type(method_ref?.current?.selectedIndex);
   } // build_mode_change();

   const build_size_change = (e) => {
      list_size_ref.current.value = e.target.value;
      set_size(e.target.value);
   } // build_size_change();

   const build_source_change = () => {
      const cnfg = {
         filter: source_ref?.current?.options[source_ref?.current?.selectedIndex].text,
         index: source_ref?.current?.selectedIndex
      }
      set_cnfg(cnfg);
   } // build_source_change();

   const build_threshold_change = (e) => {
      threshold_ref.current.value = e.target.value;
      set_hold(e.target.value);
   } // build_threshold_change();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus a warning message
      // is set, otherwise the form state is set to ENACT;
      if (file) {
         try {
            set_json(JSON.parse(file))
            set_form(FORM.ENACT);// Send any requests to the API;
         } catch {
            set_warn('The given file does not contain a valid JSON string.');
            set_form(FORM.BUILD); // Go back and wait for proper input and form submit;
         }
      } else {
         set_warn('Select a file before you submit the form.');
         set_form(FORM.BUILD); // Go back and wait for proper input and form submit;
      }
   } // check();

   const enact = async ({ set_body, set_foot, set_form, set_pass, set_warn, pass, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;
      set_warn('');

      var key_index = 1;

      var found    = false;
      var intent   = json[pass-1].intent;
      var result   = 0;
      var source   = json[pass-1].source;
      var sources  = [];

      var response = await api.fetch('que/replies/look/' + source + '/' + app.state.version_id, api.post(app.body({ filter: cnfg.filter.substr(0, 1).toLowerCase(), search_string: intent, list_size: size, method: type, threshold: hold })));

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
         }
         set_form(FORM.BUILD);
      } else {
         var class_name = '';
         var desired_id = response.data.transcript_id;
         if (!desired_id && !response?.data?.replies?.length) {
            class_name = 'ask-henry-green';
            found      = true;
            sources.push(<div className={class_name} key={key_index++}>-</div>);
            set_ok_1(ok_1 + 1);
            set_ok_2(ok_2 + 1);
            set_ok_3(ok_3 + 1);
         } else {
            for (var ith   = 0; ith < response?.data?.replies?.length; ith++) {
               class_name = '';
               if (desired_id === response.data.replies[ith].info_id) {
                  class_name = 'ask-henry-green';
                  found      = true;
               }
               sources.push(<div className={class_name} key={key_index++}>{response.data.replies[ith].rank.toFixed(4)} {response.data.replies[ith].details}</div>);
               if (0 === ith) {
                  if (desired_id === response.data.replies[ith].info_id) {
                     if (0 === result) result = 1;
                     set_ok_1(ok_1 + 1);
                     set_ok_2(ok_2 + 1);
                     set_ok_3(ok_3 + 1);
                  }
               } else if (1 === ith) {
                  if (desired_id === response.data.replies[ith].info_id) {
                     if (0 === result) result = 2;
                     set_ok_2(ok_2 + 1);
                     set_ok_3(ok_3 + 1);
                  }
               } else if (2 === ith) {
                  if (desired_id === response.data.replies[ith].info_id) {
                     if (0 === result) result = 3;
                     set_ok_3(ok_3 + 1);
                  }
               }
            }
         }

         if (!found) sources.push(<div className="ask-henry-red" key={key_index++}>{source}</div>);

         var stat = '';
         if (pass < json.length) {
            set_pass(pass + 1);
            set_foot(<button className="ask-henry-form-button" onClick={form_close} >Cancel</button>);
         } else {
            pass -= 1;
            stat  =
              <tr>
                <td></td>
                <td>
                  <table>
                    <tbody>
                      <tr><td style={{ border: 'none' }}>Method:</td><td style={{ border: 'none' }}>{mode}</td></tr>
                      <tr><td style={{ border: 'none' }}>Filter:</td><td style={{ border: 'none' }}>{cnfg.filter}</td></tr>
                      <tr><td style={{ border: 'none' }}>Threshold:</td><td style={{ border: 'none' }}>{hold}</td></tr>
                      <tr><td style={{ border: 'none' }}>List Size:</td><td style={{ border: 'none' }}>{size}</td></tr>
                    </tbody>
                  </table>
                </td>
                <td>{(100 * ok_1 / pass).toFixed(0)}% {(100 * ok_2 / pass).toFixed(0)}% {(100 * ok_3 / pass).toFixed(0)}% </td>
              </tr>
            set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
         }
         var info =
            <>
              {rows}
              <tr>
                <td>{result}</td>
                <td>{intent}</td>
                <td>{sources}</td>
              </tr>
             {stat}
            </>
         ;

         set_rows(info);

         set_body(
            <div className="ask-henry-form-test-reply-look-scroll">
              <table className="ask-henry-data-grid">
                <tbody>
                  <tr>
                    <td>Match</td>
                    <td>Intent</td>
                    <td>rank Source</td>
                  </tr>
                  {info}
                </tbody>
              </table>
           </div>
         );
      }

   } // enact();

   const form_close = () => {
      app.set_state('mode', null);
   } // form_close();

   const list_size_ref = React.useRef();
   const method_ref    = React.useRef();
   const source_ref    = React.useRef();
   const threshold_ref = React.useRef();

   return <Form build={build} check={check} class_string="ask-henry-form-test-reply-look" enact={enact} title="Test Reply Search" />

} // <ReplySearch />;

export default ReplySearch;
